import type { AlgoliaProduct, JaneSearchState } from '@jane/search/types';

const SORT_BY_PRICE_SUBSTRING = 'by-price';

export const isSortedByPrice = (
  searchState?: JaneSearchState<AlgoliaProduct>
) => {
  return Boolean(
    searchState?.currentSort?.suffix?.includes(SORT_BY_PRICE_SUBSTRING)
  );
};

export const REVIEWS_REQUIRED_BEFORE_DISPLAY = 5;
export const MIN_REVIEWS_QUERY = `review_count >= ${REVIEWS_REQUIRED_BEFORE_DISPLAY}`;
